module.exports = __webpack_public_path__ + "img/_portugal.6f53c66c.png";